import React from 'react'
import SessionDialog from '../containers/SessionDialog'
import { logoutUser } from '../../Auth/actions'

export function openDialogSession (tipo) {
  return (dispatch, getState) => {
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'SESSION',
      title: 'Sesión',
      maxWidth: 'xs',
      showPrint: false,
      content: <SessionDialog />
    })
  }
}

export function closeDialogSession () {
  return (dispatch, getState) => {
    dispatch({
      type: 'CLOSE_DIALOG',
      id: 'SESSION'
    })
    dispatch(logoutUser())
  }
}
